package prescription.containers

import com.jingfangpai.api.clients.PrescriptionApiClient
import react.*
import react.dom.div
import setTitle
import prescription.components.PrescriptionList

external interface PrescriptionListPageProps : RProps {

}

data class PrescriptionListPageContextData(var getPrescriptionList: (okCallback: (result: com.jingfangpai.common.data.response.ApiResponse<List<com.jingfangpai.common.orm.mapping.Prescription>>) -> Unit, errorCallback: (Throwable) -> Unit) -> Unit)

val PrescriptionListPageContext = createContext(PrescriptionListPageContextData({ okCallback, errorCallback -> }))

val PrescriptionListPageProvider = functionalComponent<PrescriptionListPageProps> { props ->

    setTitle("方剂")

    useEffectOnce {
        console.log("prescription list page")
    }

    PrescriptionListPageContext.Provider(PrescriptionListPageContextData(PrescriptionApiClient::getList)) {
        div("PrescriptionListPage-page") {
            child(PrescriptionList)
        }
    }
}
